function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 32,
  rx: 8,
  fill: "#F2EEFA"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12982_96177)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.8106 6.66106C40.0469 6.42482 40.4299 6.42482 40.6661 6.66106L49.2579 15.2529C49.7439 15.7389 49.7439 16.5268 49.2579 17.0128L40.6661 25.6046C40.4299 25.8408 40.0468 25.8408 39.8106 25.6046C39.5744 25.3683 39.5744 24.9853 39.8106 24.7491L48.4024 16.1573C48.4159 16.1438 48.4159 16.1219 48.4024 16.1084L39.8106 7.51654C39.5744 7.2803 39.5744 6.89729 39.8106 6.66106Z",
  fill: "#7850CD"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_12982_96177)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8106 6.66106C16.0469 6.42482 16.4299 6.42482 16.6661 6.66106L25.2579 15.2529C25.7439 15.7389 25.7439 16.5268 25.2579 17.0128L16.6661 25.6046C16.4299 25.8408 16.0468 25.8408 15.8106 25.6046C15.5744 25.3683 15.5744 24.9853 15.8106 24.7491L24.4024 16.1573C24.4159 16.1438 24.4159 16.1219 24.4024 16.1084L15.8106 7.51654C15.5744 7.2803 15.5744 6.89729 15.8106 6.66106Z",
  fill: "#7850CD"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_12982_96177)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.8106 6.66106C64.0469 6.42482 64.4299 6.42482 64.6661 6.66106L73.2579 15.2529C73.7439 15.7389 73.7439 16.5268 73.2579 17.0128L64.6661 25.6046C64.4299 25.8408 64.0468 25.8408 63.8106 25.6046C63.5744 25.3683 63.5744 24.9853 63.8106 24.7491L72.4024 16.1573C72.4159 16.1438 72.4159 16.1219 72.4024 16.1084L63.8106 7.51654C63.5744 7.2803 63.5744 6.89729 63.8106 6.66106Z",
  fill: "#7850CD"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12982_96177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(32 4)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_12982_96177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(8 4)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_12982_96177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(56 4)"
})));

const SvgArrowsRight = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 32,
    viewBox: "0 0 88 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowsRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrows-right.003ac2bc.svg";
export { ForwardRef as ReactComponent };